'use client';
import React from 'react';
import UnderlinedText from '@/components/shared/textWithUnderline';
import './PointTable.css';
// updat session id for 2024-25 season
const seasonID = 89700;
// fetch and log an api https://www.sofascore.com/api/v1/team/174598/events/next/0

const PointTable = () => {
  return (
    <>
      <UnderlinedText text="ISL STANDINGS" underlineColour="#FFD700" />
      <div className="news-card-content"></div>
      <div className="point-table-container" data-aos="slide-left">
        <div
          style={{
            height: '680px', // 883px - 132px (ad height)
            width: '100%',
            maxWidth: '768px',
            overflow: 'hidden',
            position: 'relative',
            borderRadius: '10px',
          }}
        >
          <iframe
            src={`https://widgets.sofascore.com/embed/tournament/38566/season/${seasonID}/standings?&highlightedTeamIds=174598`}
            style={{
              height: '883px', // Keep original height to ensure content renders
              width: '100%',
              border: 'none',
            }}
            frameBorder="0"
            scrolling="no"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default PointTable;
